import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import AlertSeverityBadge from "./AlertSeverityBadge";
import AlertMetricLines from "./AlertMetricLines";
import {
  buildAlertHistoryEntries,
  formatAbsoluteDate,
  maxZScore,
} from "util/cxAlertModel";
import cxStyles from "./cxAlert.module.scss";

export default function AlertHistoryModal({ open, record, onClose, theme }) {
  const { t } = useTranslation();
  const entries = buildAlertHistoryEntries(record);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <>
          {record?.kpi_name} — {t("alerts_page.history_title")}
        </>
      }
      className={theme === "dark" ? "dark-modal" : undefined}
      width={480}
    >
      <p className={cxStyles.metricLine}>
        {t("alerts_page.history_subtitle", { count: record?.fire_count_30d ?? 0 })}
      </p>
      {!entries.length && (
        <div className={cxStyles.emptyState}>{t("alerts_page.history_empty")}</div>
      )}
      {entries.map((entry, index) => (
        <div key={`${entry.fired_at}-${index}`} className={cxStyles.historyRow}>
          <div className={cxStyles.historyDate}>
            {formatAbsoluteDate(entry.fired_at)}
            <AlertSeverityBadge severity={entry.severity} />
          </div>
          <AlertMetricLines payload={entry} compact />
          {maxZScore(entry) != null && (
            <div className={cxStyles.panelFooter}>
              {t("alerts_page.z_score_label")}: {Number(maxZScore(entry)).toFixed(1)}
            </div>
          )}
          {entry._mock && (
            <div className={cxStyles.mockNote}>
              {t("alerts_page.mock_payload_note")}
            </div>
          )}
        </div>
      ))}
    </Modal>
  );
}
